import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_lKXy2LL1zwNx: {
	id: 'prd_lKXy22DEV2LL1zwNx'
	ident: 'prd_lKXy2LL1zwNx'
	sku: 'simple_premium_12w_19_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_HTcHE2DEV2kzm7UnX'
			amount: 79
			amount_usd: 19.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 19.99
			discount: 59.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_KrQ0h2DEV2XeYAI7L'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_lKXy2LL1zwNx, SubscriptionProduct>
const prd_lKXy2LL1zwNx = { ident: 'prd_lKXy2LL1zwNx' } as typeof _prd_lKXy2LL1zwNx

export default prd_lKXy2LL1zwNx
